import { render, staticRenderFns } from "./ActivityConfigAutoInitModal.vue?vue&type=template&id=b3026568&scoped=true"
import script from "./ActivityConfigAutoInitModal.vue?vue&type=script&lang=js"
export * from "./ActivityConfigAutoInitModal.vue?vue&type=script&lang=js"
import style0 from "./ActivityConfigAutoInitModal.vue?vue&type=style&index=0&id=b3026568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3026568",
  null
  
)

export default component.exports